@use '@/styles/tokens' as *;

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-4);
  padding-bottom: var(--space-6);
  border-bottom: 1px solid $color-neutral-200;
  // margin-bottom: var(--space-8);
  background-image: url(./../../../assets/images/order-detail-header-bg.webp);
  background-repeat: no-repeat;
  background-size: cover;
  padding: var(--space-8) var(--space-6);
}

.left {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  gap: var(--space-3);
  align-items: flex-start;
}

.back {
  background: none;
  border: none;
  padding: var(--space-1);
  cursor: pointer;
  color: $color-neutral-950;
  display: inline-flex;
  margin-top: 4px;
}

.identity {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.nameRow {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-width: 0;
}

// A long name gives way before the order number does (ADO 121002).
.name {
  @include truncate;
  min-width: 0;
  margin: 0;
  font-family: $font-family-heading;
  font-size: 24px;
  font-weight: 500;
  color: $color-neutral-950;
}

.orderNo {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 14px;
  color: $color-neutral-950;
}

.contacts {
  display: flex;
  gap: var(--space-6);
  flex-wrap: wrap;
}

.contact {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 14px;
  color: $color-neutral-700;
}

.right {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-shrink: 0;
}

.invoiceButton {
  background-color: $color-white-50 !important;
  span {
    :first-of-type {
      width: 16px;
      height: 16px;
    }
  }
}
